import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NewsService, NewsItem } from '../../services/news.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-news',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './news.component.html',
})
export class NewsComponent implements OnInit {
  news: NewsItem[] = [];

  constructor(private newsService: NewsService, private router: Router) {}

  ngOnInit(): void {
    this.newsService.getAll().subscribe((data) => {
      this.news = data;
    });
  }

  openNews(id: number) {
    this.router.navigate(['/news', id]);
  }
}
